import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { sandyUTConfig } from "./data";

export default function SandyUTPage() {
  return <CityPageTemplate config={sandyUTConfig} />;
}